<style scoped>
.width-500{
  width: 250px;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Hat-Port Olmayanlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "HAT&PORT OLMAYANLAR",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "HAT&PORT OLMAYANLAR",
          active: true,
        },
      ],
      routerList:[],
      isLoading: false,
      rows: [],
      paginationOptions: {},
      form:{},
      selectOptions: { enabled: false,},
      columns: [
        {
          label: 'Hat-Port Olmayan Sayısı',
          field: 'cnt',
          sortable: false,
        },
        {
          label: 'Son Online Olduğu Mikrotik',
          field: this.mikrotikbilgi,
          sortable: false,
        },
        {
          label: 'Hat Port Verilecek Mikrotik',
          field: '#',
          sortable: false,
          thClass: 'width-500',
        },
        {
          field: 'action',
          sortable: false,
          thClass: 'width-50',
        },
      ],
    };
  },
    mounted() {
      this.loadItems()
        this.$http.post('/routers')
      .then(resp => this.routerList = resp.data.data )
    },
    methods: {
      mikrotikbilgi(obj){
        return obj.nasipaddress + ' - ' + obj.shortname;
      },
      loadItems() {
          this.getFromServer(this.serverParams).then(response => {
            this.rows = response.rows
          })
      },
      getFromServer() {
          return new Promise((resolve, reject) => {
              this.$http.post('control/hatport', this.serverParams)
              .then(res => {
                  resolve({
                    rows: res.data,
                  })
              })
              .catch(error => {
                  reject(error)
              })
          })
      },
      ata(id){
        this.$http.post('control/topluata', { atanacakrouter:this.form.newrouterid, onlinerouter:this.rows[id].id })
        .then(response => response)
      },
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                 
                  <v-select 
                    v-model="form.newrouterid"
                    :filterable="false"
                    :options="routerList"
                    label="nasname"
                    :reduce="r => r.id">
                  </v-select>
                  </span>
                  <span
                    v-else-if="props.column.field === 'action'"
                    class="text-nowrap"
                  >
                  <button 
                    @click="ata(props.row.originalIndex)"
                    type="button" 
                    class="btn btn-outline-success">
                    <i class="mdi mdi-trash-can-outline"></i>
                    <span>  Ata </span>
                  </button>
                  </span> 
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>